import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { supabase } from '../../lib/supabase';

interface WhatsAppConfig {
  numero_whatsapp: string;
  ativo: boolean;
}

const WhatsAppButton = () => {
  const [config, setConfig] = useState<WhatsAppConfig | null>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    fetchConfig();

    // Subscrever a mudanças na configuração
    const subscription = supabase
      .channel('whatsapp_config_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'whatsapp_config'
        },
        () => {
          fetchConfig();
        }
      )
      .subscribe();

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const fetchConfig = async () => {
    try {
      const { data, error } = await supabase
        .from('whatsapp_config')
        .select('numero_whatsapp, ativo')
        .maybeSingle();

      if (error) throw error;
      setConfig(data);
    } catch (error) {
      console.error('Erro ao carregar configuração WhatsApp:', error);
    }
  };

  const handleClick = () => {
    if (config?.numero_whatsapp) {
      // Remove todos os caracteres não numéricos
      const numeroLimpo = config.numero_whatsapp.replace(/\D/g, '');
      // Abre o WhatsApp com o número configurado
      window.open(`https://wa.me/${numeroLimpo}`, '_blank');
    }
  };

  // Não mostrar o botão se não estiver ativo ou não houver número
  if (!config?.ativo || !config?.numero_whatsapp) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.button
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0, opacity: 0 }}
        transition={{ duration: 0.3 }}
        onClick={handleClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="fixed bottom-8 right-8 z-50 w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-full shadow-2xl flex items-center justify-center cursor-pointer group hover:shadow-green-500/50 transition-all duration-300"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        {/* Animação de pulso */}
        <motion.div
          className="absolute inset-0 bg-green-500 rounded-full"
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.5, 0, 0.5]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />

        {/* Ícone WhatsApp */}
        <i className="ri-whatsapp-fill text-4xl text-white relative z-10"></i>

        {/* Tooltip */}
        <AnimatePresence>
          {isHovered && (
            <motion.div
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
              className="absolute right-full mr-4 px-4 py-2 bg-luxury-black/95 text-white text-sm font-medium rounded-lg shadow-xl whitespace-nowrap"
            >
              Fale connosco no WhatsApp
              <div className="absolute top-1/2 -right-1 transform -translate-y-1/2 w-2 h-2 bg-luxury-black/95 rotate-45"></div>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.button>
    </AnimatePresence>
  );
};

export default WhatsAppButton;
